module.exports = __webpack_public_path__ + "static/media/missions.e6cbdce7.png";